import List from "@/modules/dis/service/inspection/private/List";

const setAssignedUnits = function (location, assignments) {
    const units = [];
    location.units.forEach(unit => {
        const assignment = assignments.find(assignment => "" + assignment.unit.id === "" + unit.id && List.sameOrder(assignment, unit));
        if (assignment) {
            unit.order           = assignment.order;
            unit.technicianId    = assignment.technicianId;
            unit.technicianName  = assignment.technicianName;
            unit.technicianIdent = assignment.technicianIdent;
            units.push (unit)
        } else {
            unit.order = null;
            unit.technicianId    = null;
            unit.technicianName  = null;
            unit.technicianIdent = null;
        }
    })

    const unitWithTechnician = location.units.find(unit => unit.technicianId);
    if (unitWithTechnician) {
        location.technicianId    = unitWithTechnician.technicianId;
        location.technicianName  = unitWithTechnician.technicianName;
        location.technicianIdent = unitWithTechnician.technicianIdent;
    } else {
        location.technicianId    = null;
        location.technicianName  = null;
        location.technicianIdent = null;
    }

    const unitWithOrder = location.units.find(unit => unit.order);
    if (unitWithOrder) {
        location.order = unitWithOrder.order;
    } else {
        location.order = null;
    }

    location.assignedUnits = units;
};



export default {
    NULL_ASSIGNMENT: null,

    /**
     * Converts the given unit in a location record.
     *
     * @param unit the unit data
     * @return the location record.
     */
    toLocation (unit) {
        return {
            row    : unit.row,
            id     : unit.id,
            zip    : unit.zip,
            city   : unit.city,
            street : unit.street,
            contact: unit.contact,
            units  : unit.units
        };
    },

    /**
     * Publishes changes on the given assignments. If the assignment list is empty, all units
     * of the given location will be updated.
     *
     * @param component
     * @param order
     * @param location
     * @param assignmentList
     * @param assignments
     */
    publishAssignments (component, order, location, assignmentList, assignments) {
        const modifiedUnits = [ location.id ];

        if (assignmentList) {
            assignmentList.forEach(assignment => {
                const index = assignments.findIndex (a => a.id === assignment.id && List.sameOrder(a, assignment));
                if (index >= 0) {
                    assignments.splice(index, 1);
                }

                assignments.push(assignment);
                component.$bus.$emit (component.$events.dis.inspection, assignment);
                modifiedUnits.push(assignment.unit.id)
            });
        } else {
            location.units.forEach(unit => {
                modifiedUnits.push(unit.id)
            });
        }

        setAssignedUnits (location, assignments)
        component.$store.dispatch("setAssignments", assignments).then(() => {
            component.$bus.$emit (component.$events.dis.assignments, {
                order      : order,
                assignments: assignments,
                units      : modifiedUnits
            });
        });
    }
}